module.exports = __webpack_public_path__ + "img/5f8799dee75a0c974773e767d9939264.svg";